import { render, staticRenderFns } from "./typography.vue?vue&type=template&id=40d0bb12"
import script from "./typography.vue?vue&type=script&lang=js"
export * from "./typography.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports